import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { useApi } from '../../util/lib';
import HtmlHead from '../UI/Head/HtmlHead';

import css from './RpryEstimation.module.css';

export const RpryEstimation = () => {
  const [pristine, setPristine] = useState(true)
  const [error, setError] = useState()
	const api = useApi();
  const { code, id } = useParams();
  const estimationCode = code || id;
  useEffect(() => {
    const parseEstimation = async () => {
      try {
        if (!pristine) return
        setPristine(false)
        const response = await api({
          method: 'get',
          responseType: 'json',
          url: `/sdk/estimations/${estimationCode}`,
        });
        console.log(response.data)
        if (response.data && response.data.shopCode) {
          const shopCode = response.data.shopCode;
          const baseUrl = (
            process.env.REACT_APP_REPAIRY_BOOK_V2_URL ||
            process.env.REACT_APP_REPAIRY_BOOK_URL
          );
          const redirectUrl = `${baseUrl}/${shopCode}/estimation/${estimationCode}`;
          window.location.href = redirectUrl;
        } else {
          throw new Error('No shopCode found');
        }
      } catch (error) {
        console.error(error)
        setError(error)
      }
    }
    parseEstimation();
  }, [api, estimationCode, pristine])
  return (
    <>
      <HtmlHead repairy />

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        {error && (
          <p>
            Opps! Seems like we cant provide you a service now. 
            Please contact support if problem persists
          </p>
        )}
        {!error && (
          <img
            alt='rpry-icon'
            src='/rpry-icon.svg'
            className={css.RpryLogo} />
        )}
      </div>
    </>
  );
}
